/**
 * Minimal scroll reveal for the dark site: elements carrying `.rise` get
 * `.is-in` once ~15% of them is visible. Reveals stay under 300 ms (see
 * App.css) so no screen is ever blank mid-scroll. Returns a disposer.
 *
 * Usage (class component):
 *   componentDidMount() { this.dispose = observeRise(this.rootRef.current); }
 *   componentWillUnmount() { if (this.dispose) this.dispose(); }
 */
export function observeRise(root) {
  if (typeof window === 'undefined' || !root) return () => {};
  const nodes = root.classList && root.classList.contains('rise')
    ? [root, ...root.querySelectorAll('.rise')]
    : Array.from(root.querySelectorAll('.rise'));
  if (nodes.length === 0) return () => {};
  if (!('IntersectionObserver' in window) ||
      (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    nodes.forEach(n => n.classList.add('is-in'));
    return () => {};
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  nodes.forEach(n => io.observe(n));
  return () => io.disconnect();
}
